import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AppLayout from "../layouts/AppLayout";
import NotFound from "../pages/NotFound";
import MovieDetails from "../pages/MovieDetails";
import Movies from "../pages/Movies";
import SignIn from "../pages/SignIn";
import { requiresAuth } from "../loaders/RequiresAuth";
import { Loading } from "../components/Loading";

/**
 * 1. 에러 발생 시 보여줄 컴포넌트
 * error.message에 접근하기 위해 error를 Error 타입으로 명시합니다.
 */
function ErrorFallback({ error }: FallbackProps) {
  return (
    <div className="error-container">
      <p>에러 발생:</p>
      {/* error를 Error 타입으로 단언하여 message 속성에 접근 */}
      <pre style={{ color: "red" }}>{(error as Error).message}</pre>
    </div>
  );
}

// 지연 로딩 컴포넌트
const Home = Loading(() => import("../pages/Home"), {
  loading: <div>홈 화면 불러오는 중...</div>,
});
const About = Loading(() => import("../pages/About"));
const Blog = Loading(() => import("../pages/Blog"));
const Lab = Loading(() => import("../pages/Lab"));
const Lotto = Loading(() => import("../pages/LottoMain"));

/**
 * 2. 라우터 설정
 */
const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Home />
          </ErrorBoundary>
        ),
      },
      {
        path: "/about",
        element: (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <About />
          </ErrorBoundary>
        ),
      },
      {
        path: "/blog",
        element: (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Blog />
          </ErrorBoundary>
        ),
      },
      {
        path: "/lab",
        element: (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Lab />
          </ErrorBoundary>
        ),
      },
      {
        path: "/lab/lotto",
        element: (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Lotto />
          </ErrorBoundary>
        ),
      },
      {
        path: "/signin",
        element: <SignIn />,
      },
      {
        path: "/movies",
        element: <Movies />,
        loader: requiresAuth,
        children: [
          {
            path: ":movieId",
            element: <MovieDetails />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

export default function Router() {
  return <RouterProvider router={router} />;
}